import { createFileRoute } from '@tanstack/react-router';
import { ContactListPage } from '../components/mail/ContactListPage';

export const Route = createFileRoute('/mail/contacts')({
  component: ContactListPage,
});
